import Icon from "./Icon";

const STARBUCKS_LOCATIONS = {
  ATL: "Concourses A, B, C, D, E, F, T",
  BOS: "Terminal A, Terminal B (Gates B20-B22), Terminal C",
  CDG: "Terminal 2E (Hall M), Terminal 2F",
  CLT: "Concourse B, Concourse C, Concourse D, Concourse E",
  CMH: "Concourse B",
  DEN: "Concourse A, Concourse B, Concourse C",
  DFW: "Terminal A, Terminal B, Terminal C, Terminal D, Terminal E",
  DTW: "McNamara Terminal, North Terminal",
  EWR: "Terminal A, Terminal B, Terminal C",
  FCO: "Terminal 1, Terminal 3",
  FLL: "Terminal 1, Terminal 3, Terminal 4",
  FRA: "Terminal 1 (A, B, C gates), Terminal 2",
  HNL: "Overseas Terminal",
  IAD: "Main Terminal, Concourse B, Concourse C",
  IAH: "Terminal A, Terminal B, Terminal C, Terminal D, Terminal E",
  JFK: "Terminal 1, Terminal 2, Terminal 4, Terminal 5, Terminal 8",
  LAS: "Terminal 1, Terminal 3",
  LAX: "Terminals 1, 2, 3, 4, 5, 6, 7, Tom Bradley International",
  LGA: "Terminal B, Terminal C, Terminal D",
  LHR: "Terminal 2, Terminal 3, Terminal 4, Terminal 5",
  MAD: "Terminal 4, Terminal 4S",
  MCO: "Gate Area A, Gate Area B, Gate Area C, Gate Area D",
  MDW: "Concourse A, Concourse B",
  MIA: "Concourse D, Concourse E, Concourse H, Concourse J",
  MSP: "Terminal 1 (Concourse C, F, G), Terminal 2",
  NRT: "Terminal 1, Terminal 2",
  ORD: "Terminal 1, Terminal 2, Terminal 3",
  PDX: "Concourse C, Concourse D, Concourse E",
  PHL: "Terminal A-East, Terminal B/C, Terminal D/E, Terminal F",
  PHX: "Terminal 3, Terminal 4",
  SEA: "Concourse A, Concourse B, Concourse C, Concourse D",
  SFO: "Terminal 1, Terminal 2, Terminal 3, International Terminal",
  SIN: "Terminal 1, Terminal 2, Terminal 3",
  SLC: "Concourse A, Concourse B, Concourse C",
  TPA: "Airside A, Airside C, Airside E, Airside F",
  YUL: "Pier B, Pier C, Pier F",
  YVR: "International Terminal, Domestic Terminal",
  YYZ: "Terminal 1, Terminal 3",
  AMS: "Departure Lounge 1, 2, 3",
  DXB: "Terminal 1, Terminal 3",
  HKG: "Terminal 1",
  SYD: "Terminal 1 International",
  AUS: "Barbara Jordan Terminal",
  BNA: "Concourse C, Concourse D",
  RDU: "Terminal 1, Terminal 2",
};

const IATA_TO_ICAO = {
  AA: 'AAL', UA: 'UAL', DL: 'DAL', BA: 'BAW', LH: 'DLH',
  AF: 'AFR', KL: 'KLM', IB: 'IBE', EK: 'UAE', QR: 'QTR',
  LX: 'SWR', TK: 'THY', AC: 'ACA', WN: 'SWA', B6: 'JBU',
  AS: 'ASA', F9: 'FFT', NK: 'NKS', HA: 'HAL', VS: 'VIR',
  EI: 'EIN', AY: 'FIN', SK: 'SAS', OS: 'AUA', FR: 'RYR',
  U2: 'EZY', CX: 'CPA', JL: 'JAL', NH: 'ANA', KE: 'KAL',
  SQ: 'SIA', MH: 'MAS', TG: 'THA', QF: 'QFA', NZ: 'ANZ',
  ET: 'ETH', AM: 'AMX', CM: 'CMP', AV: 'AVA', LA: 'LAN'
};

function extractAirports(segment) {
  const match = segment.title?.match(/^([A-Z]{3})\s*[-–>→]+\s*([A-Z]{3})/);
  if (match) return { departure: match[1], arrival: match[2] };
  const single = segment.title?.match(/^([A-Z]{3})/);
  if (single) return { departure: single[1], arrival: null };
  return { departure: null, arrival: null };
}

function getFlightAwareUrl(segment) {
  const text = `${segment.detail || ""} ${segment.title || ""}`;
  const match = text.match(/\b([A-Z]{2})(\d{1,4})(?![A-Z0-9])/);
  if (!match) return null;
  const icao = IATA_TO_ICAO[match[1]] || match[1];
  return `https://www.flightaware.com/live/flight/${icao}${match[2]}`;
}

function AirportSection({ code, label }) {
  const starbucks = STARBUCKS_LOCATIONS[code];

  return (
    <div style={{ marginBottom: 16, padding: "12px 14px", background: "var(--paper-warm)", borderRadius: "var(--radius-sm)", border: "1px solid var(--border)" }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: "var(--ink-light)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 10 }}>
        {label}: {code}
      </div>

      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 8 }}>
        <div style={{ display: "flex", alignItems: "flex-start", gap: 8, flex: 1 }}>
          <span style={{ fontSize: 16 }}>☕</span>
          <div>
            <div style={{ fontSize: 13, fontWeight: 500, color: "var(--ink)" }}>Starbucks airside</div>
            {starbucks ? (
              <div style={{ fontSize: 11, color: "var(--ink-light)", marginTop: 2 }}>{starbucks}</div>
            ) : (
              <div style={{ fontSize: 11, color: "var(--ink-light)", marginTop: 2 }}>Not confirmed</div>
            )}
          </div>
        </div>
        <div style={{ fontSize: 13, fontWeight: 600, color: starbucks ? "#2C7A4B" : "var(--ink-faint)", flexShrink: 0, marginLeft: 8 }}>
          {starbucks ? "✓" : "✗"}
        </div>
      </div>

      <div style={{ display: "flex", gap: 8, marginTop: 8, justifyContent: "center" }}>
        <a
          href={`https://www.tsawaittimes.com/security-wait-times/${code}`}
          target="_blank" rel="noreferrer"
          className="seg-btn"
          style={{ flex: 1, justifyContent: "center", fontSize: 11 }}
        >
          🛡 TSA Wait Times
        </a>

      </div>
    </div>
  );
}

export default function AirportInfoModal({ segment, onClose }) {
  const { departure, arrival } = extractAirports(segment);
  const flightAwareUrl = getFlightAwareUrl(segment);

  if (!departure) {
    return (
      <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
        <div className="modal">
          <div className="modal-header">
            <div className="modal-title">Airport Info</div>
            <button className="modal-close" onClick={onClose}><Icon name="close" size={14} /></button>
          </div>
          <div style={{ fontSize: 13, color: "var(--ink-light)", textAlign: "center", padding: "20px 0" }}>
            Could not determine airport.<br/>Make sure flight title is in "JFK → CDG" format.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <div>
            <div className="modal-title">Airport Info</div>
            <div style={{ fontSize: 12, color: "var(--ink-light)" }}>{segment.title}</div>
          </div>
          <button className="modal-close" onClick={onClose}><Icon name="close" size={14} /></button>
        </div>

        <AirportSection code={departure} label="Departing from" />
        {arrival && <AirportSection code={arrival} label="Arriving at" />}

        {flightAwareUrl && (
          <a href={flightAwareUrl} target="_blank" rel="noreferrer"
            className="seg-btn primary"
            style={{ display: "flex", justifyContent: "center", width: "100%", textDecoration: "none", marginTop: 4 }}>
            ✈️ Track Flight on FlightAware
          </a>
        )}
      </div>
    </div>
  );
}
